import React, { Component } from 'react';
import $ from 'jquery';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './Global';
import './App.scss'

import 'antd/dist/antd.css';
import './styles/bootstrap.scss';
import './styles/app.scss';
import './Vendor';
// import 'semantic-ui-css/semantic.min.css';
import RecoverPasswors from './components/RR/RecoverPassword/';
import LoginComponent from './components/RR/Login/';
import HomeComponent from './components/RR/Dashboard/index';
// import DashboardComponent from './components/RR/Dashboard/index';
import TrackingComponent from './components/RR/Tracking/ShipmentTracking';
import TrackingDetailComponent from './components/RR/Tracking/ShipmentDetails';
import ContainerComponent from './components/RR/ContainerManagement/Index';
import ContainerManagementDetail from './components/RR/ContainerManagement/ContainerDetail/Index';
import ReportsComponent from './components/RR/Reports/';
import AdminComponent from './components/RR/Admin/Admin';
import WrapperRoute from './components/Middlewares/WrapperRoute';
import NotFound from './components/template/pages/notFound';
import ContainerDetailComponent from './components/RR/Tracking/Components/Container/ContainersDetail';
import Alerts from './components/RR/Alerts';
import Terminos from './components/template/pages/termino-condiciones';
import Aviso from './components/template/pages/aviso-de-privacidad';
import MyReportsCreate from './components/RR/Reports/MyReports/Create'
import CostManagement from './components/RR/CostManagement'
import CustomerService from './components/RR/Customer Service/Help_Desk';
import ServiceDesk from './components/RR/servicedeskmodule';
import TicketDetails from './components/RR/servicedeskmodule/app/TicketDetails';







import QuickSearch from './components/RR/QuickSearch';


import history from './history';

$.ajaxPrefilter(o => o.async = true);


/*=============================================
=            App Component With Router        =
=============================================*/

class App extends Component {

  render() {
    return (
      <BrowserRouter history={history} basename={'/'}>
        <Switch>
          <Route exact path="/" component={LoginComponent}></Route>
          <Route exact path="/Home" render={() => <WrapperRoute name={'Home'} component={HomeComponent} ></WrapperRoute>}></Route>
          {/* <Route exact path="/Dashboard" render={() => <WrapperRoute name={''} component={DashboardComponent} ></WrapperRoute>}></Route> */}
          <Route exact path="/Tracking" render={() => <WrapperRoute name={'Tracking'} component={TrackingComponent} ></WrapperRoute>}></Route>
          <Route exact path="/Container" render={() => <WrapperRoute name={'Container'} component={ContainerComponent} ></WrapperRoute>}></Route>
          <Route exact path="/Reports" render={() => <WrapperRoute name={'Reports'} component={ReportsComponent} ></WrapperRoute>}></Route>
          <Route exact path="/Admin" render={() => <WrapperRoute name={'Admin'} component={AdminComponent} ></WrapperRoute>}></Route>
          <Route exact path="/Alerts" render={() => <WrapperRoute name={'Alerts'} component={Alerts} ></WrapperRoute>} />
          <Route exact path="/terminos-y-condiciones" component={Terminos} />
          <Route exact path="/aviso-de-privacidad" component={Aviso} />
          <Route exact path="/reports/creation" render={() => <WrapperRoute name={'myreports_create'} component={ MyReportsCreate } ></WrapperRoute>}/>
          <Route exact path="/Cost-Management" render={() => <WrapperRoute name={'Cost-Management'} component={ CostManagement } ></WrapperRoute>}/>
          <Route exact path="/Help-Desk" render={() => <WrapperRoute name={'Help-Desk'} component={CustomerService} ></WrapperRoute>}></Route>

          <Route exact path="/Service-Desk" render={() => <WrapperRoute name={'Service-Desk'} component={ServiceDesk} ></WrapperRoute>}></Route>

          <Route exact path="/Detail/:id" render={() => <WrapperRoute name={'shipmentsDetail'} component={TicketDetails} ></WrapperRoute>} />


          {/* Routes with params */}
          <Route exact path="/shipmentsDetail/:id" render={() => <WrapperRoute name={'shipmentsDetail'} component={TrackingDetailComponent} ></WrapperRoute>} />
          <Route exact path="/Container-Detail/:id" render={() => <WrapperRoute name={'shipmentsDetail'} component={ContainerDetailComponent} ></WrapperRoute>} />
          <Route exact path="/container-management-detail/:id" render={() => <WrapperRoute name={'containerManagementDetail'} component={ContainerManagementDetail} ></WrapperRoute>} />
          <Route exact path="/recoverpassword/:token" component={RecoverPasswors}></Route>
          <Route exact path="/search/:id*" render={() => <WrapperRoute name={'quick_search'} component={QuickSearch} ></WrapperRoute>} />
          <Route component={NotFound} />

        </Switch>

      </BrowserRouter>
    );
  }
}

export default App;
